import { putAPI, getAPI } from './api-service'
import { optionsForSurvey } from './service-helper'

export const loadSurveysAPI = async ({ currentSurveysOnly }) => {
  return getAPI(
    'ResultsAPI',
    '/surveys',
    optionsForSurvey({ currentSurveysOnly })
  ).then((surveys) => {
    return surveys.sort((a, b) => {
      return new Date(b.details.end_date) - new Date(a.details.end_date)
    })
  })
}

export const loadSurveyDetailsAPI = async ({
  surveyName,
  currentSurveysOnly
}) => {
  return getAPI(
    'ResultsAPI',
    `/surveys/${surveyName}`,
    optionsForSurvey({ currentSurveysOnly })
  )
}

export const loadSurveyDetailsWithFilteredCategoriesAPI = async ({
  surveyName
}) => {
  return getAPI('SurveyAPI', `/surveys/${surveyName}`)
}

export const setSurveyFinishedAPI = async ({
  surveyName,
  surveyTitle,
  surveyEndDate,
  locale,
  usersName,
  variant
}) => {
  const body = {
    surveyTitle,
    surveyEndDate,
    locale,
    usersName
  }
  if (variant) {
    body.variant = variant
  }
  return putAPI('SurveyAPI', `/surveys/${surveyName}/finished`, { body })
}
